module.exports = __webpack_public_path__ + "static/media/exclamation.8632a4d5.jpg";